import React from 'react';

/**
 * Pillar Card Component
 *
 * Visual card for displaying one of the five LRB pillars.
 */

// Icon components for each pillar
const PillarIcons = {
  community: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  brain: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2a4 4 0 0 1 4 4c0 1.1-.4 2.1-1 2.9.6.8 1 1.8 1 2.9 0 1.1-.4 2.1-1 2.9.6.8 1 1.8 1 2.9a4 4 0 0 1-4 4" />
      <path d="M12 2a4 4 0 0 0-4 4c0 1.1.4 2.1 1 2.9-.6.8-1 1.8-1 2.9 0 1.1.4 2.1 1 2.9-.6.8-1 1.8-1 2.9a4 4 0 0 0 4 4" />
      <circle cx="12" cy="9" r="1" fill="currentColor" />
      <circle cx="12" cy="15" r="1" fill="currentColor" />
    </svg>
  ),
  mountain: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 3l4 8 5-5 5 15H2L8 3z" />
      <path d="M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19" />
    </svg>
  ),
  key: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 0-7.778 7.778 5.5 5.5 0 0 0 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
  ),
  network: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="5" r="3" />
      <circle cx="5" cy="19" r="3" />
      <circle cx="19" cy="19" r="3" />
      <path d="M12 8v4M8.5 14.5L5 16M15.5 14.5L19 16" />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </svg>
  )
};

const colorClasses = {
  '#1F93FE': 'pillar-card--blue',
  '#667eea': 'pillar-card--purple',
  '#764ba2': 'pillar-card--violet',
  '#10b981': 'pillar-card--green',
  '#F7521B': 'pillar-card--coral'
};

const PillarCard = ({
  title,
  tagline,
  description,
  icon = 'brain',
  color = '#1F93FE',
  onClick
}) => {
  const IconComponent = PillarIcons[icon] || PillarIcons.brain;
  const colorClass = colorClasses[color] || 'pillar-card--blue';

  return (
    <div
      className={`pillar-card ${colorClass}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="pillar-card__icon">
        {IconComponent}
      </div>
      <h3 className="pillar-card__title">{title}</h3>
      {tagline && <p className="pillar-card__tagline">{tagline}</p>}
      <p className="pillar-card__description">{description}</p>
    </div>
  );
};

export default PillarCard;
